export default "__VITE_ASSET__BscoH9sA__"